import React, { FunctionComponent, useMemo } from "react";
import {
  Stack,
  Flex,
  StyleProps,
  useColorModeValue,
} from "@chakra-ui/react";

import CardTitle from "components/card-title"

interface IProps extends StyleProps {
  title?: string;
  subTitle?: string;
  subTitleTooltip?: string;
  alarmsLink?: string;
  highlighted?: boolean;
  icon?: string;
  onClick?: () => void;
}

const Card: FunctionComponent<IProps> = ({
  title,
  subTitle,
  subTitleTooltip,
  alarmsLink,
  highlighted,
  icon,
  children,
  ...rest
}) => {
  const highlightedBg = useColorModeValue("enposol.50", "enposol.950");
  const highlightedBorder = useColorModeValue("enposol.500", "enposol.500");
  const regularBorder = useColorModeValue("gray.200", "gray.800");
  const borderColor = useMemo(() => highlighted ? highlightedBorder : regularBorder, [highlighted, highlightedBorder, regularBorder]);

  return (
    <Flex
      direction={"column"}
      align={"stretch"}
      boxShadow={"xl"}
      rounded={"md"}
      overflow={"hidden"}
      border="3px solid"
      borderColor={borderColor}
      bg={highlighted ? highlightedBg : undefined}
      position="relative"
      {...rest}
    >
      {title && (
        <CardTitle
          title={title}
          subTitle={subTitle}
          subTitleTooltip={subTitleTooltip}
          icon={icon}
          alarmsLink={alarmsLink}
        />
      )}
      <Stack
        flexGrow={1}
      >
        {children}
      </Stack>
    </Flex>
  );
};

export default Card;
